import { Component, Input, forwardRef, HostBinding } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ModalPage } from "src/app/modals/modal/modal.page";
import { ModalController } from "@ionic/angular";
import { Global } from "../../../../global";

@Component({
  selector: "app-thumbnail",
  templateUrl: "./thumbnail.control.html",
  styleUrls: ["./thumbnail.control.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ThumbnailControl),
      multi: true,
    },
  ],
})
export class ThumbnailControl implements ControlValueAccessor {
  @Input("value") value: string;
  @Input("Content_GUID") Content_GUID: string;
  @Input("description") description: string;
  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(
    public globals: Global,
    public modalController: ModalController
  ) {}

  writeValue(value: any) {
    if (value) {
      this.Content_GUID = value;
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    //throw new Error("Method not implemented.");
  }

  async onThumbnailClick(
    event: any,
    key: any,
    Content_GUID: any,
    modalHeading: any
  ) {
    var paramObject = {
      modalType: "contentViewer",
      modalBodyText: "",
      modalHeaderText: modalHeading,
      Content_GUID: Content_GUID,
    };

    const modal = await this.modalController.create({
      component: ModalPage,
      componentProps: {
        paramObject: paramObject,
      },
      cssClass: "modal-fullscreen",
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
      }
    });
    return await modal.present();
  }
}
